var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('img',{attrs:{"data-cy":"devcode-logo","src":require('../assets/devcode-logo.png'),"alt":"devcode logo"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-cy":"devcode-title"}},[_c('h1',[_vm._v("I'm ready for the next challenge!")])])
}]

export { render, staticRenderFns }